// The Security Checklist fields that Import from Contract fills, so the only ones that can be flagged
// "Not found during AI extraction" (every other wizard field - the classifications, the Comment - is simply not part
// of the import). Mirror of the [ExtractionField]s on the backend ContractExtractionResult, where the Retain Until
// date is read as a number of days after the Opportunity ends; shared by the import panel (which lists the ones the
// contract did not yield) and the review window description (which captions them).
const ImportCoveredChecklistFieldsArray = [
  'ContactName',
  'ContactEmail',
  'ContactPhone',
  'AuthorizedClientBusinessRep',
  'SecurityIncidentNotification',
  'PrivacyBreachNotification',
  'SubjectInquiryNotification',
  'ErasureNotification',
  'ClientOperationalContactsExport',
  'DeliveredEvaluationDetailsExport',
  'DataFlowMap',
  'DataFlowMapFreeText',
  'ClientAccountContactsData',
  'ClientOperationalContactsData',
  'DeliveredEvaluationDetails',
  'ApprovedLogoUsage',
  'ApprovedNameUsage',
  'DataTransferRequired',
  'DataRetentionDefined',
  'DataRetainUntilUtc',
  'RetentionDetail',
];

export default ImportCoveredChecklistFieldsArray;
